let display_when = (event) => {
    event.preventDefault();
    let $el = $(event.currentTarget);
    let val = parseInt($el.val());
    let displayWhen = $el.data('display-when');

    // An array to store selectors of elements to hide.
    let toHide = [];
    let toShow = [];

    // Loop through the values in 'displayWhen'.
    for (let key in displayWhen) {
        // Split the value into two selectors.
        let selectors = displayWhen[key]
            .split(',')
            .map(selector => selector.trim());

        if (parseInt(key) === val) {
            toShow = toShow.concat(selectors);
        } else {
            toHide = toHide.concat(selectors);
        }
    }

    // Hide the elements specified in 'toHide'.
    for (let selector of toHide) {
        if (!toShow.includes(selector)) {
            $(selector).hide();
            $(selector).find('input').val('');
            $(selector).find('select').val('').trigger('change');
        }
    }

    for (let selector of toShow) {
        $(selector).show();
    }
}

export default display_when;
